import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';

import { ComponentCommService } from '../../../services/component-comm.service';

/**
 * Página "Estado SSTA", accesible desde el menú de la empresa.
 *
 * Es un contenedor delgado: toda la lógica vive en `ag-stop-cookies`, el mismo
 * componente que se usaba como solapa dentro de Integraciones.
 *
 * POR QUÉ SALIÓ DE INTEGRACIONES
 * ==============================
 * Integraciones exige `commercial_with_users` para aparecer en el menú, así que
 * la única vía de acceso dejaba afuera a la mayoría de los usuarios de una
 * empresa — justo los que operan cupos y necesitan saber si la sincronización
 * con SSTA está sana. Acá no hay condición de rol: alcanza con pertenecer a la
 * empresa.
 *
 * Lo que protege el botón de renovación (que sí dispara un login real contra un
 * sitio de gobierno) vive en el backend: idempotencia, tope global de 3 por día,
 * cooldown de 15 minutos y lock de concurrencia.
 */
@Component({
  selector: 'ag-ssta-status',
  templateUrl: './ssta-status.component.html'
})
export class SstaStatusComponent implements OnInit, OnDestroy {

  public companyId: number;

  private subscriptions: Subscription[] = [];

  constructor(
    private componentComm: ComponentCommService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.componentComm.emit({ name: 'app-title', title: 'STOP_COOKIES.MENU_TITLE' });

    this.subscriptions.push(
      this.route.parent.params.subscribe((params: Params) => {
        this.companyId = parseInt(params['companyId']);
      })
    );
  }

  /** @ignore */
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
